module.exports = __webpack_public_path__ + "img/policeIndustrySolution.jpg";